import React from 'react';
import { Link } from 'react-router-dom';
import { scrollToTop } from '../hooks/useScrollToTop';

export const Footer: React.FC = () => {
  // Handle link clicks with scroll to top
  const handleLinkClick = () => {
    // Small delay to allow route change to start
    setTimeout(() => scrollToTop('smooth'), 50);
  };

  return (
    <footer className="bg-gray-100 border-t border-gray-200 mt-auto safe-bottom">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* About Section */}
          <div>
            <h3 className="font-semibold text-gray-800 mb-3">About TinnitusTune</h3>
            <p className="text-sm text-gray-600">
              Free tool that identifies your tinnitus frequency 
              and provides notched sound therapy.
            </p>
          </div>
          
          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-gray-800 mb-3">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" onClick={handleLinkClick} className="text-purple-600 hover:text-purple-700">
                  Tinnitus Frequency Test
                </Link>
              </li>
              <li>
                <Link to="/notched-white-noise" onClick={handleLinkClick} className="text-purple-600 hover:text-purple-700">
                  Notched White Noise Therapy
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Resources */}
          <div>
            <h3 className="font-semibold text-gray-800 mb-3">Resources</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/about-tinnitus" onClick={handleLinkClick} className="text-purple-600 hover:text-purple-700">
                  About Tinnitus & FAQ
                </Link>
              </li>
              <li>
                <Link to="/how-it-works" onClick={handleLinkClick} className="text-purple-600 hover:text-purple-700">
                  How It Works
                </Link>
              </li>
              <li>
                <a href="https://www.nidcd.nih.gov/health/tinnitus" target="_blank" rel="noopener noreferrer" className="text-purple-600 hover:text-purple-700">
                  NIDCD Resources ↗
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Disclaimer Section */}
        <div className="mt-6 pt-4 border-t border-gray-200">
          <div className="bg-gray-50 rounded-lg p-4 text-center">
            <p className="text-sm text-gray-600 mb-2">
              <strong>Important:</strong> Not medical advice. For informational purposes only.
            </p>
            <p className="text-xs text-gray-500">
              TinnitusTune helps identify tinnitus frequencies and provides notched sound therapy for informational purposes. 
              Always consult healthcare professionals for diagnosis and treatment. 
              <Link to="/legal" onClick={handleLinkClick} className="text-purple-600 hover:text-purple-700 underline ml-1">
                Full disclaimer
              </Link>
            </p>
          </div>
        </div>
        
        <div className="mt-6 pt-6 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-600">
              © 2025 <a href="https://soepel.it" target="_blank" rel="noreferrer" className="text-purple-600 hover:text-purple-700">Soepel IT</a>, Enschede | Free for everyone
            </p>
            <div className="text-sm">
              <Link to="/legal" onClick={handleLinkClick} className="text-gray-600 hover:text-purple-600">
                Privacy & Terms
              </Link>
            </div>
          </div>
          
        </div>
      </div>
    </footer>
  );
};